function getEvents(pageId, mediumMediaId) {
  return {
    events: {
      "e-3": {
        id: "e-3",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_OVER",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-4",
          },
        },
        mediaQueries: ["main"],
        target: {
          id: `${pageId}|${mediumMediaId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${mediumMediaId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1692796117288,
      },
      "e-4": {
        id: "e-4",
        name: "",
        animationType: "preset",
        eventTypeId: "MOUSE_OUT",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-3",
          },
        },
        mediaQueries: ["main"],
        target: {
          id: `${pageId}|${mediumMediaId}`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|${mediumMediaId}`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1692796117288,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Layout 423 Card [Hover In]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  value: 0,
                  unit: "",
                },
              },
              {
                id: "a-n-2",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  yValue: 100,
                  xUnit: "PX",
                  yUnit: "%",
                  zUnit: "PX",
                },
              },
              {
                id: "a-n-3",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  heightValue: 0,
                  widthUnit: "PX",
                  heightUnit: "px",
                  locked: false,
                },
              },
              {
                id: "a-n-11",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_overlay",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9b"],
                  },
                  value: 0.8,
                  unit: "",
                },
              },
              {
                id: "a-n-5",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: true,
                    id: `${pageId}|5612b694-7091-b920-4dc3-bfb0eeec9132`,
                  },
                  widthValue: 50,
                  widthUnit: "%",
                  heightUnit: "PX",
                  locked: false,
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-n-6",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "outQuart",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  value: 1,
                  unit: "",
                },
              },
              {
                id: "a-n-7",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "outQuart",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  yValue: 0,
                  xUnit: "PX",
                  yUnit: "%",
                  zUnit: "PX",
                },
              },
              {
                id: "a-n-8",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "outQuart",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  widthUnit: "PX",
                  heightUnit: "AUTO",
                  locked: false,
                },
              },
              {
                id: "a-n-12",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_overlay",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9b"],
                  },
                  value: 1,
                  unit: "",
                },
              },
              {
                id: "a-n-10",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "outQuart",
                  duration: 300,
                  target: {
                    useEventTarget: true,
                    id: `${pageId}|5612b694-7091-b920-4dc3-bfb0eeec9132`,
                  },
                  widthValue: 70,
                  widthUnit: "%",
                  heightUnit: "PX",
                  locked: false,
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1691568376441,
      },
      "a-2": {
        id: "a-2",
        title: "Layout 423 Card [Hover Out]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-2-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "outQuart",
                  duration: 200,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  value: 0,
                  unit: "",
                },
              },
              {
                id: "a-2-n-2",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "outQuart",
                  duration: 200,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  yValue: 100,
                  xUnit: "PX",
                  yUnit: "%",
                  zUnit: "PX",
                },
              },
              {
                id: "a-2-n-3",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "outQuart",
                  duration: 200,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_card-content-bottom",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9a"],
                  },
                  heightValue: 0,
                  widthUnit: "PX",
                  heightUnit: "px",
                  locked: false,
                },
              },
              {
                id: "a-2-n-6",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 200,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout423_overlay",
                    selectorGuids: ["da639e21-867c-4c95-3588-52826c5bdc9b"],
                  },
                  value: 0.7,
                  unit: "",
                },
              },
              {
                id: "a-2-n-5",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 200,
                  target: {
                    useEventTarget: true,
                    id: `${pageId}|5612b694-7091-b920-4dc3-bfb0eeec9132`,
                  },
                  widthValue: 50,
                  widthUnit: "%",
                  heightUnit: "PX",
                  locked: false,
                },
              },
            ],
          },
        ],
      },
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
